var _excluded = ["onClick", "isActive"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../../../contexts/OnColorContext";
import { KeyboardEventKeys } from "../../../../../../typings/types";
import getIconColor from "../../../../../../utils/getIconColor";
import unit from "../../../../../../utils/unit";
var hamburgerWidth = 20;
var hamburgerHeight = 14;
var lineHeight = 2;
var timingFunction1 = "cubic-bezier(0.55, 0.055, 0.675, 0.19)";
var timingFunction2 = "cubic-bezier(0.33333, 0.66667, 0.66667, 1)";
var timingFunction3 = "cubic-bezier(0.33333, 0, 0.66667, 0.33333)";
var lineBaseStyles = function lineBaseStyles(onColor) {
  return css(["position:absolute;width:", ";height:", ";background-color:", ";"], unit(hamburgerWidth), unit(lineHeight), function (props) {
    return getIconColor(props.theme, onColor);
  });
};
var Wrapper = styled.div.withConfig({
  componentId: "sc-1ncdmwr-0"
})(["display:inline-flex;position:relative;width:", ";height:", ";cursor:pointer;"], unit(hamburgerWidth), unit(hamburgerHeight));
var Lines = styled.div.withConfig({
  componentId: "sc-1ncdmwr-1"
})(function (_ref) {
  var $isActive = _ref.$isActive,
    $onColor = _ref.$onColor;
  return css(["", ";bottom:0;transition:transform 0.13s ", ";transition-delay:0.13s;&::before,&::after{", ";content:\"\";}&::before{top:", ";transition:top 0.2s 0.2s ", ",opacity 0.1s linear;}&::after{top:", ";transition:top 0.12s 0.2s ", ",transform 0.13s ", ";}", ""], lineBaseStyles($onColor), timingFunction1, lineBaseStyles($onColor), unit(-1 * (hamburgerHeight - lineHeight)), timingFunction2, unit(-1 * (hamburgerHeight - lineHeight) / 2), timingFunction2, timingFunction1, $isActive && css(["transform:translate3d( 0,", ",0 ) rotate(-45deg);&::before{top:0;opacity:0;transition:top 0.2s ", ",opacity 0.1s 0.22s linear;}&::after{top:0;transform:rotate(-90deg);transition:top 0.1s 0.16s ", ",transform 0.13s 0.25s cubic-bezier(0.215,0.61,0.355,1);}"], unit(-1 * (hamburgerHeight - lineHeight) / 2), timingFunction3, timingFunction3));
});
function HamburgerAtm(_ref2) {
  var onClick = _ref2.onClick,
    isActive = _ref2.isActive,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER) {
      onClick();
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    onClick: onClick,
    onKeyDown: handleKeyDown,
    tabIndex: 0
  }, restProps), /*#__PURE__*/React.createElement(Lines, {
    $isActive: !!isActive,
    $onColor: onColor
  }));
}
export default HamburgerAtm;